import 'whatwg-fetch'
import {message} from 'antd'
import {LAST_MONTH, LAST_YEAR, NO_DISCOUNT, THIS_MONTH, THIS_YEAR, TODAY, YESTERDAY,} from './const'
import {CLUB_ID} from '../containers/ClubBusiness/constants'
import moment from 'moment'
import emptyPicture from '../assert/images/empty_picture.jpg'

// 校验上传文件是否为允许的图片类型（jpg/jpeg/png）
export function validateImageFile(file) {
    const allowedTypes = ['image/jpeg', 'image/png']
    if (file && allowedTypes.indexOf(file.type) > -1) {
        return true
    }
    message.error('只能上传 JPG/PNG 格式的图片')
    return false
}

export function fetchData(endpoint, isReturnRES = false) {
    let myHeader = {
        headers: {
            Authorisation: sessionStorage.getItem('s'),
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Club-Id': sessionStorage.getItem(CLUB_ID) || '',
        },
        method: 'GET',
    }
    return new Promise((resolve, reject) => {
        fetch(endpoint, myHeader)
            .then((res) => {
                if (res.status == 401) {
                    message.error('很抱歉,您没有权限')
                } else if (res.status == 403) {
                    message.error('本次登录已过期,请重新登录', 2, () => {
                        window.location.href = '/'
                    })
                }
                if (isReturnRES) {
                    resolve(res)
                    return
                }
                resolve(res.json())
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export function exportData(endpoint, method = 'post', body = {}) {
    let myHeader = {
        headers: {
            Authorisation: sessionStorage.getItem('s'),
            'Club-Id': sessionStorage.getItem(CLUB_ID),
        },
        method: method,
        body,
    }
    return fetch(endpoint, myHeader)
        .then((res) => {
            if (res.status == 401) {
                message.error('很抱歉,您没有权限')
            } else if (res.status == 403) {
                message.error('本次登录已过期,请重新登录', 2, () => {
                    window.location.href = '/'
                })
            }
            return res.blob()
        })
        .catch((e) => {
            console.log(e.message)
        })
}

export function postData(endpoint, method = 'post', body = {}) {
    let methods = ['GET', 'POST', 'DELETE', 'PUT']
    let myHeader = {
        headers: {
            Authorisation: sessionStorage.getItem('s'),
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Club-Id': sessionStorage.getItem(CLUB_ID),
        },
        method: methods[methods.indexOf(method.toUpperCase())],
        body: body,
    }
    return fetch(endpoint, myHeader)
        .then((res) => {
            if (res.status == 401) {
                message.error('很抱歉,您没有权限')
            } else if (res.status == 403) {
                message.error('本次登录已过期,请重新登录', 2, () => {
                    window.location.href = '/'
                })
            }
            return res.json()
        })
        .catch((error) => {
            console.log(error.message)
        })
}

export function obj_to_query(path = '/', obj) {
    let parts = []
    for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
            parts.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]))
        }
    }
    return path + '?' + parts.join('&')
}

export function parseTime(timeString) {
    if (timeString == '') return null
    let time = timeString.replace(
        /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/,
        '$1/$2/$3 $4:$5'
    )
    let d = new Date(time)
    return d
}

export function round(number, precision = 0) {
    let factor = Math.pow(10, precision)
    let tempNumber = number * factor
    let roundedTempNumber = Math.round(tempNumber)
    return roundedTempNumber / factor
}

export function getDefault(arr, key, defaultValue) {
    if (arr.hasOwnProperty(key)) {
        return arr[key]
    } else {
        return defaultValue
    }
}

export function setTitle(title) {
    document.title = title
    if (/ip(hone|od|ad)/i.test(navigator.userAgent)) {
        let i = document.createElement('iframe')
        i.src = '/favicon.ico'
        i.style.display = 'none'
        i.onload = function () {
            setTimeout(function () {
                i.remove()
            }, 9)
        }
        document.body.appendChild(i)
    }
}

//导出报表
export function clickDownload(columns, list) {
    let str = [],
        title = []
    columns.map((item) => {
        title.push(item.title)
    })
    str.push(title.join(','))
    for (let i = 0; i < list.length; i++) {
        let temp = []
        for (let j = 0; j < columns.length; j++) {
            temp.push(list[i][columns[j].dataIndex])
        }
        str.push(temp.join(','))
    }
    str = encodeURIComponent(str.join('\n'))
    return 'data:text/csv;charset=utf-8,\ufeff' + str
}

//导出预订报表
export function clickDownloadReserved(columns, list) {
    let str = [],
        title = []
    columns.map((item) => {
        title.push(item.title)
    })
    str.push(title.join(','))
    for (let i = 0; i < list.length; i++) {
        let temp = []
        for (let j = 0; j < columns.length; j++) {
            temp.push(list[i].bills[0][columns[j].dataIndex[2]])
        }
        str.push(temp.join(','))
    }
    str = encodeURIComponent(str.join('\n'))
    return 'data:text/csv;charset=utf-8,\ufeff' + str
}

//进销存设置-库存流水-销售记录-导出报表
export function leadoutSaleTable(list) {
    if (list.length > 0) {
        let str = [],
            origin_title = [],
            title = []
        list.map((item, index) => {
            // if (item.amount) {
            //   item.amount = item.amount / 100
            // }
            item.state == 3 ? (item.stateText = '退货') : (item.stateText = '')
        })
        origin_title = list.length > 0 ? Object.keys(list[0]) : []
        origin_title &&
        origin_title.map((item, index) => {
            if (
                item == 'date' ||
                item == 'name' ||
                item == 'stateText' ||
                item == 'quantity' ||
                item == 'amount' ||
                item == 'profit'
            ) {
                title.push(item)
            }
        })
        title &&
        title.map((item, index) => {
            if (item == 'date') {
                title.unshift(title.splice(index, 1)[0])
            }
        })
        const newTitle = title
        str.push(newTitle.join(','))
        list &&
        list.map((item, index) => {
            let temp = []
            title &&
            title.map(($item, $index) => {
                if ($item != 'type') {
                    temp.push(item[$item])
                } else {
                    switch (item[$item]) {
                        case 1:
                            temp.push('进货')
                            break
                        case 2:
                            temp.push('撤销订单')
                            break
                        case 3:
                            temp.push('调入')
                            break
                        case 4:
                            temp.push('销售')
                            break
                        case 5:
                            temp.push('调出')
                            break
                        case 6:
                            temp.push('销毁')
                            break
                        case 7:
                            temp.push('退库')
                            break
                        case 8:
                            temp.push('套餐赠送')
                            break
                        case 9:
                            temp.push('团购赠送')
                            break

                        default:
                            break
                    }
                }
            })
            str.push(temp.join(','))
        })
        let word_title = str[0]
        str.splice(0, 1)
        word_title = word_title.split(',')
        word_title &&
        word_title.map((item, index) => {
            switch (item) {
                case 'date':
                    word_title[index] = '日期'
                    break
                case 'name':
                    word_title[index] = '商品名称'
                    break
                case 'stateText':
                    word_title[index] = '状态'
                    break
                case 'quantity':
                    word_title[index] = '数量'
                    break
                case 'amount':
                    word_title[index] = '销售价格（元）'
                    break
                case 'profit':
                    word_title[index] = '利润（元）'
                    break

                default:
                    break
            }
        })
        str.unshift(word_title.join(','))
        str = encodeURIComponent(str.join('\n'))
        return 'data:text/csv;charset=utf-8,\ufeff' + str
    } else {
        return null
    }
}

//默认时间
export function startTime(isIgnoreTime = false) {
    let start_time = new Date()
    // start_time.setHours(17, 0)
    start_time.setHours(8, 0, 0)
    start_time.setDate(1)
    if (isIgnoreTime) {
        return start_time.toISOString().slice(0, 10)
    } else {
        return start_time.toISOString().slice(0, 16).replace(/T/, ' ')
    }
}

export function endTime(isIgnoreTime = false) {
    let end_time = new Date()
    // end_time.setHours(17, 0)
    end_time.setHours(8, 0, 0)
    if (isIgnoreTime) {
        return end_time.toISOString().slice(0, 10)
    } else {
        end_time.setDate(end_time.getDate() + 1)
        return end_time.toISOString().slice(0, 16).replace(/T/, ' ')
    }
}

//把'2019-01-21 00:00'变为'2019.01.21'
export function changeStringTime(stringTime) {
    return stringTime ? stringTime.substring(0, 10).replace(/-/g, '.') : ''
}

//把'1970-01-01 08:00:00.000000'变为'2019.01.21 08:00:00'
export function changeStringTime2(stringTime) {
    return stringTime ? stringTime.substring(0, 19).replace(/-/g, '-') : ''
}

//把2019-01-22 00:00 变为moment
export function strTimetoMoment(str) {
    return moment(str, 'YYYY-MM-DD')
}

//  将秒数转换成 天时分秒
export function toHourMinuteSecond(value) {
    if (!value || value == 0 || value == '') {
        return {
            day: '0',
            hour: '0',
            minute: '0',
            second: '0',
        }
    }
    var days = Math.floor(value / 86400)
    var hours = Math.floor((value % 86400) / 3600)
    var minutes = Math.floor(((value % 86400) % 3600) / 60)
    var seconds = Math.floor(((value % 86400) % 3600) % 60)
    return {
        day: days,
        hour: hours,
        minute: minutes,
        second: seconds,
    }
}

//  按小时转化时长
export function toServeTime(value) {
    if (!value || value == 0 || value == '') {
        return {
            hour: '0',
            minute: '0',
            second: '0',
        }
    }
    var hours = Math.floor(value / 3600)
    var minutes = Math.floor(((value % 86400) % 3600) / 60)
    var seconds = Math.floor(((value % 86400) % 3600) % 60)
    return {
        hour: hours,
        minute: minutes,
        second: seconds,
    }
}

//  按小时转化时长(向上取整分钟)
export function toUpServeTime(value) {
    if (!value || value == 0 || value == '') {
        return {
            hour: '0',
            minute: '0',
            second: '0',
        }
    }
    var hours = Math.floor(value / 3600)
    var minutes = Math.floor(((value % 86400) % 3600) / 60)
    var seconds = Math.floor(((value % 86400) % 3600) % 60)
    minutes += 1
    if (minutes == 59) {
        hours += 1
        minutes = 0
    }
    return {
        hour: hours,
        minute: minutes,
        second: seconds,
    }
}

// 计算时分
export function calculationTime(startTime, endTime) {
    var text
    var sDate = new Date(startTime)
    var eDate = new Date(endTime)
    if (startTime && endTime) {
        var minutes = Math.floor((eDate.getTime() - sDate.getTime()) / 60000)
        if (minutes <= 60) {
            text = minutes + '分'
        } else {
            var hour = Math.floor(minutes / 60)
            var minute = minutes % 60
            text = hour + '时' + minute + '分'
        }
    } else {
        text = ''
    }
    return text
}

//将金额转换成保留小数点后两位的小数
export function changeToDecimal(num) {
    if (typeof +num !== 'number') {
        return num
    } else {
        let result
        if (num) {
            let f = Math.round(parseFloat(num) * 100) / 100
            if (!isNaN(f)) {
                result = f.toString()
                let rs = result.indexOf('.')
                if (rs < 0) {
                    rs = result.length
                    result += '.'
                }
                while (result.length <= rs + 2) {
                    result += '0'
                }
            }
        } else {
            result = num
        }
        return isNaN(result) ? 0 : result
    }
}

//复制文本到剪贴板
export function copyToClip(content) {
    let aux = document.createElement('input')
    aux.setAttribute('value', content)
    document.body.appendChild(aux)
    aux.select()
    document.execCommand('copy')
    document.body.removeChild(aux)
    message.info('已复制文本到剪贴板')
}

export function getCurrentTimeByType(type) {
    let startTime = new Date()
    let endTime = new Date()
    if (type === YESTERDAY) {
        //昨天
        startTime.setDate(startTime.getDate() - 1)
        endTime.setDate(endTime.getDate() - 1)
    } else if (type === TODAY) {
        //今日
        //startTime = endTime
    } else if (type === LAST_MONTH) {
        //上月
        startTime.setMonth(startTime.getMonth() - 1, 1)
        endTime.setMonth(endTime.getMonth())
        endTime.setDate(0) //1
    } else if (type === THIS_MONTH) {
        //本月
        startTime.setDate(1)
    } else if (type === LAST_YEAR) {
        //去年
        startTime.setFullYear(startTime.getFullYear() - 1)
        startTime.setMonth(0)
        startTime.setDate(1)
        endTime.setFullYear(endTime.getFullYear() - 1)
        endTime.setMonth(11)
        endTime.setDate(31)
        // endTime.setMonth(0);
        // endTime.setDate(1);
    } else if (type === THIS_YEAR) {
        //今年
        startTime.setMonth(0)
        startTime.setDate(1)
        // endTime.setDate(endTime.getDate() + 1);
    }
    return {
        start_time: moment(startTime).format('YYYY-MM-DD'),
        end_time: moment(endTime).format('YYYY-MM-DD'),
    }
}

export function fenToYuan(amount) {
    if (!amount) return 0
    return changeToDecimal(amount / 100)
}

// 验证手机号码
export function checkPhoneNum(phone) {
    if (!phone) {
        return false
    }
    const reg =
        /^((\+|00)86)?1[3-9]\d{9}$|^(852)?\d{8}$|^(853)?\d{8}$|^((886|0)9)?\d{8}$/ //验证规则
    return reg.test(phone)
}

export function checkVerifyCode(code) {
    if (!code || code.length < 4 || code.length > 6) {
        console.log('验证码长度不对')
        return false
    }
    const reg = /^[0-9]{4,6}$/ //验证规则
    return reg.test(code)
}

//返回显示折购的文本
export const DiscountText = (text) =>
    +text === NO_DISCOUNT ? '无折扣' : +changeToDecimal(+text * 10) + '折'

export function getLastMonth() {
    const nowdays = new Date()
    nowdays.setHours(0, 0, 0, 0)
    let year = nowdays.getFullYear()
    let month = nowdays.getMonth()
    if (month === 0) {
        month = 12
        year = year - 1
    }
    if (month < 10) {
        month = '0' + month
    }
    const firstDay = year + '-' + month + '-' + '01' // 上个月的第一天
    const myDate = new Date(year, month, 0)
    myDate.setHours(0, 0, 0, 0)
    const lastDay = year + '-' + month + '-' + myDate.getDate() // 上个月的最后一天
    return {
        firstDay,
        lastDay,
    }
}

// 把ISO 8601时间变为YYYY-MM-DD HH:mm:ss
export const toNormalTime = (time) => {
    return moment(time).format('YYYY-MM-DD HH:mm:ss')
}

// 显示图片适配URL
export const fixPhotoUrl = (url, isSave = false) => {
    if (url.includes("undefined") || url === "https://images.sport147.cn" || !url.trim()) {
        return !isSave ? emptyPicture : ''
    }
    const reg = new RegExp('http')
    let photoUrl = reg.test(url) ? url : 'https://images.sport147.cn' + url
    return photoUrl
}

//进销存设置-库存流水-销售记录&进出记录-导出报表
export function leadoutTable(list) {
    if (list.length > 0) {
        let str = [],
            origin_title = [],
            title = []
        list.map((item, index) => {
            item.createTime = moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
        })
        origin_title = list.length > 0 ? Object.keys(list[0]) : []
        origin_title &&
        origin_title.map((item, index) => {
            if (
                item == 'date' ||
                item == 'name' ||
                item == 'storeName' ||
                item == 'init' ||
                item == 'type' ||
                item == 'quantity' ||
                item == 'balance' ||
                item == 'createTime' ||
                item == 'operatorName'
            ) {
                title.push(item)
            }
        })
        title &&
        title.map((item, index) => {
            if (item == 'date') {
                title.unshift(title.splice(index, 1)[0])
            }
        })
        const newTitle = title
        str.push(newTitle.join(','))
        list &&
        list.map((item, index) => {
            let temp = []
            title &&
            title.map(($item, $index) => {
                if ($item != 'type') {
                    temp.push(item[$item])
                } else {
                    switch (item[$item]) {
                        case 1:
                            temp.push('进货')
                            break
                        case 2:
                            temp.push('撤销订单')
                            break
                        case 3:
                            temp.push('调入')
                            break
                        case 4:
                            temp.push('销售')
                            break
                        case 5:
                            temp.push('调出')
                            break
                        case 6:
                            temp.push('销毁')
                            break
                        case 7:
                            temp.push('退库')
                            break
                        case 8:
                            temp.push('套餐赠送')
                            break
                        case 9:
                            temp.push('团购赠送')
                            break

                        default:
                            break
                    }
                }
            })
            str.push(temp.join(','))
        })
        let word_title = str[0]
        str.splice(0, 1)
        word_title = word_title.split(',')
        word_title &&
        word_title.map((item, index) => {
            switch (item) {
                case 'date':
                    word_title[index] = '日期'
                    break
                case 'name':
                    word_title[index] = '商品名称'
                    break
                case 'storeName':
                    word_title[index] = '仓库'
                    break
                case 'init':
                    word_title[index] = '原库存'
                    break
                case 'type':
                    word_title[index] = '进出类型'
                    break
                case 'quantity':
                    word_title[index] = '数量'
                    break
                case 'balance':
                    word_title[index] = '现库存'
                    break
                case 'createTime':
                    word_title[index] = '操作时间'
                    break
                case 'operatorName':
                    word_title[index] = '操作人'
                    break

                default:
                    break
            }
        })
        str.unshift(word_title.join(','))
        str = encodeURIComponent(str.join('\n'))
        return 'data:text/csv;charset=utf-8,\ufeff' + str
    } else {
        return null
    }
}

/**
 * 修复元到分计算问题
 * @param amount 金额
 * @returns {string|number} 修复后的金额
 */
export function fixYuanToFen(amount) {
    return amount ? (amount * 100).toFixed(0) : 0
}

/**
 * 修复分钟到秒计算问题
 * @param duration 时长
 * @returns {string|number} 修复后的时长
 */
export function fixMinuteToSecond(duration){
    return duration ? (duration * 60).toFixed(0) : 0
}



//进销存设置-库存流水-商品库存-导出报表
export function leadoutStockTable(list) {
    if (list.length > 0) {
        let str = [],
            title = [],
            tit = []
        title.push('storeId')
        title.push('storeName')
        tit = list.length > 0 ? Object.keys(list[0].stockSummaries[0]) : []
        title = title.concat(tit)
        tit = title
        tit &&
        tit.map((item, index) => {
            if (item == 'photoUrl') {
                tit.splice(index, 1)
            }
        })
        console.log(tit)
        str.push(tit.join(','))

        list.map((item, index) => {
            item.stockSummaries &&
            item.stockSummaries.map(($item, $index) => {
                $item.unitCost = $item.unitCost / 100
                $item.storeId = item.store.id
                $item.storeName = item.store.name
                let temp = []
                title &&
                title.map(($$item, $$index) => {
                    temp.push($item[$$item])
                })
                str.push(temp.join(','))
            })
        })

        let word_title = str[0]
        str.splice(0, 1)
        word_title = word_title.split(',')
        word_title &&
        word_title.map((item, index) => {
            switch (item) {
                case 'storeId':
                    word_title[index] = '仓库ID'
                    break
                case 'storeName':
                    word_title[index] = '仓库名称'
                    break
                case 'listingId':
                    word_title[index] = '商品ID'
                    break
                case 'name':
                    word_title[index] = '商品名称'
                    break
                case 'photoUrl':
                    word_title[index] = '图片'
                    break
                case 'quantity':
                    word_title[index] = '数量'
                    break
                case 'unitCost':
                    word_title[index] = '成本'
                    break

                default:
                    break
            }
        })
        str.unshift(word_title.join(','))

        str = encodeURIComponent(str.join('\n'))
        return 'data:text/csv;charset=utf-8,\ufeff' + str
    } else {
        return null
    }
}

// 返回链接中？号后面的所有参数 组成一个对象返回
export const getQueryString = (str) => {
    var queryString = str.split('?')[1] || ''
    if (!queryString || queryString.length == 0) {
        return null
    }
    var arr = queryString.split('&') || []
    var dict = {}
    for (var i = 0; i < arr.length; i++) {
        var keyString = decodeURIComponent(arr[i].split('=')[0])
        var valueString = decodeURIComponent(arr[i].split('=')[1])
        dict[keyString] = valueString
    }
    return dict
}

// 判断是否有值
export const isValuable = (str) => {
    str = str + ''
    str = str.toString().trim()
    if (!str || str == '' || str.length == 0 || str == undefined) {
        return false
    }
    return true
}

// 判断时间是否为1970, 如果是, 返回'-'
export const isDefaultYear = (date, format = 'YYYY-MM-DD HH:mm:ss') => {
    const year = moment(date).year()
    if (year == 1970) {
        return '-'
    } else {
        return moment(date).format(format)
    }
}



// WEBPACK FOOTER //
// ./src/util/index.js